import { useEffect, useState, useCallback } from "react";
import { getAllComparisonResearchQueries } from "../services/comparisonResearchQueries";

interface IComparisonResearchQueryItem {
  id: number;
  name: string;
  code: string;
  description?: string;
  rule_id?: number | null;
}

interface IUseFetchAllComparisonResearchQueries {
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  fetchOnMount?: boolean;
}

const useFetchAllComparisonResearchQueries = ({
  setIsLoading,
  fetchOnMount = true,
}: IUseFetchAllComparisonResearchQueries = {}) => {
  const [allComparisonResearchQueries, setAllComparisonResearchQueries] =
    useState<IComparisonResearchQueryItem[]>([]);
  const [isLoadingQueries, setIsLoadingQueries] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchQueries = useCallback(async () => {
    setIsLoadingQueries(true);
    setError(null);
    if (setIsLoading) {
      setIsLoading(true);
    }
    try {
      const result = await getAllComparisonResearchQueries();
      // Ensure result is an array before setting state
      setAllComparisonResearchQueries(Array.isArray(result) ? result : []);
    } catch (err: any) {
      console.error("Error fetching comparison research queries:", err);
      setAllComparisonResearchQueries([]);
      setError(err?.message || "Failed to fetch comparison research queries");
    } finally {
      setIsLoadingQueries(false);
      if (setIsLoading) {
        setIsLoading(false);
      }
    }
  }, [setIsLoading]);

  useEffect(() => {
    if (fetchOnMount) {
      fetchQueries();
    }
  }, [fetchOnMount, fetchQueries]);

  return {
    allComparisonResearchQueries,
    isLoadingQueries,
    error,
    refetchQueries: fetchQueries,
  };
};

export default useFetchAllComparisonResearchQueries;

